<template>
    <div class="testers-list" v-if="allTesters.length">
        <div class="testers-list-item" :class="{'-big': isBig}" v-for="(org, index) in allTesters.slice(0,2)">
            <AuthorTooltip :info="org" :isSert="info.status && info.status.alias === 'has_certificate'"
                           :position="position">
                <TestAuthor :info="org" :is-big="isBig"/>
            </AuthorTooltip>
        </div>
        <div class="testers-list-item" v-if="allTesters.length > 2">
            <AuthorTooltip :info="allTesters.slice(2)"
                           :position="position">
                <span class="author-logo-counter" :class="{'-big': isBig}">+{{allTesters.length - 2}}</span>
            </AuthorTooltip>
        </div>
    </div>
    <Tooltip v-else text="Не перевірений">
        <NoInfo />
    </Tooltip>
</template>

<script>
import AuthorTooltip from "./AuthorTooltip";
import TestAuthor from "./TestAuthor";
import NoInfo from './NoInfo';
import Tooltip from './Tooltip';
export default {
    name: "TestersList",
    components: {Tooltip, NoInfo, TestAuthor, AuthorTooltip},
    props: ['info', 'testers', 'isMobile', 'isBig', 'position'],
    computed: {
        allTesters() {
            function sortFunction( a, b ) {
                const name1 = a.name;
                const name2 = b.name;
                if ( name1 < name2 ){
                    return -1;
                }
                if ( name1 > name2 ){
                    return 1;
                }
                return 0;
            }

            let allTesters = [];

            if (this.testers) {
                allTesters = Object.create(this.testers)
            } else {
                this.info.tests.forEach(item => {
                    allTesters = allTesters.concat(item.experts).concat(item.organizations);
                })
            }

            allTesters.sort(sortFunction);
            const COTCCC = allTesters.filter(item => item.name === 'CoTCCC');

            if(COTCCC.length) {
                allTesters.unshift(COTCCC[0]);
            }

            const key = 'name';
            let uniqueTesters = [...new Map(allTesters.map(item => [item[key], item])).values()];

            return uniqueTesters;
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/front/helpers";
.testers-list {
    display: flex;
    align-items: center;

    @include responsive-below($sm){
        padding-right: 20px;
    }

    &-item {
        margin-right: -10px;
        display: flex;
        align-items: center;
        position: relative;

        &.-big {
            margin-right: -20px;
        }

        .author {
            margin-right: 0;
        }
    }
}

.author-logo-counter {
    min-width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border: solid 1px #4578EB;
    font-size: 10px;
    color: #4578EB;
    border-radius: 50%;

    &.-big {
        min-width: 48px;
        height: 48px;
        font-size: 11px;

        @include responsive-below($xs) {
            min-width: 40px;
            height: 40px;
        }
    }
}
</style>
